import { cls } from "library/cls.mjs"
import { raise } from "library/local-events/index.mjs"
function getContext() {
    const activeContext = cls?.context && typeof cls.context === "object" ? cls.context : {}
    raise("OverrideContext", activeContext)
    return activeContext
}
export { getContext }
